import { Component, Input, OnInit } from '@angular/core';
import { EMailAudit } from '../../../classes';

@Component({
  selector: 'app-mail-label',
  templateUrl: './mail-label.component.html',
  styleUrls: ['./mail-label.component.css']
})
export class MailLabelComponent implements OnInit {

  @Input() mail: EMailAudit;

  constructor() { }

  ngOnInit(): void {
  }

}
